'use client';

import { useSyncExternalStore } from 'react';

// Reads the site-wide theme by observing the palette class on `<html>`. The class
// is set by the FOUC-prevention script in `app/layout.tsx` before hydration and
// kept in sync by the colorPalette bridge, so this works even before the app
// effects bootstrap has mounted. `useSyncExternalStore` avoids the
// effect-delayed first paint a `useEffect`/`useState` reader would cause and
// gives a stable server snapshot.
//
// Both `dark` and `accessible-dark` are dark themes. The palette applier
// (`Palette.ts`) maps the accessible dark palette to the `accessible-dark` class
// and removes `dark`, so checking only for `dark` would misread accessible dark
// mode as light.

const DARK_PALETTE_CLASSES = ['dark', 'accessible-dark'];

const subscribe = (callback: () => void): (() => void) => {
    const observer = new MutationObserver(callback);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
};

const getSnapshot = (): boolean =>
    typeof document !== 'undefined' &&
    DARK_PALETTE_CLASSES.some((className) => document.documentElement.classList.contains(className));

const getServerSnapshot = (): boolean => false;

export const useIsDarkMode = (): boolean => useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
